import { useState } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"
import { useNavigate } from "react-router-dom"

const useFaqForm = () => {
    const navigate = useNavigate()
    const [isSaving, setIsSaving] = useState(false)
    const [payload, setPayload] = useState({
        Title: '',
        Answer: '',
        Order: '',
        Active: undefined
    })
    const [activeOptions, setActiveOptions] = useState([
        {
            'label': 'Active',
            'value': true
        },
        {
            'label': 'Not Active',
            'value': false
        },
    ])

    const handleSelectStatus = (value) => {
        setPayload({
            ...payload,
            Active: value
        })
    };

    const onChangeHandler = (e) => {
        if (e.target.name === "Order") {
            setPayload({ ...payload, [e.target.name]: parseInt(e.target.value) })
        } else {
            setPayload({ ...payload, [e.target.name]: e.target.value })
        }
    }

    const postFaq = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.post('/auth/faqs', payload)
            if (res.status === 200) {
                navigate(-1)
                toast.success("Success Create Faq")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }

    }

    const putFaq = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.put('/auth/faqs', payload)
            if (res.status === 200) {
                navigate(-1)
                toast.success("Success Update Faq")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    const getFaq = async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/faqs/${id}`)
            if (res.status === 200) {
                setPayload(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        payload,
        onChangeHandler,
        postFaq,
        putFaq,
        getFaq,
        activeOptions,
        isSaving,
        handleSelectStatus,
    }
}

export default useFaqForm